module.exports = __webpack_public_path__ + "static/img/003_TO8_1461.7629539.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/003_TO8_1461.jpg
// module id = Oiy5
// module chunks = 0